export default "__VITE_ASSET__Bu4m5znH__"